import { Outlet } from 'react-router';
import { AuthGuard } from '@/components/AuthGuard';
import { useGetCurrentUserQuery } from '@/app/services/authApi';

export function RootLayout() {
  // Initialize auth state on app startup by triggering the query
  useGetCurrentUserQuery();

  return (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  );
}
